import {
  DetailsFormFieldProps,
  DisplayProps,
  NumberInputWithSuggestionsProps,
} from "models/propTypes/wintFormPropsTypes";
import NumberDisplay from "../formDisplays/numberDisplay";
import DetailsFormBaseField from "./detailsFormBaseField";
import NumberInputWithSuggestions from "../formFields/numberInputWithSuggestions";

const NumberFieldWithSuggestions = (props: NumberInputWithSuggestionsProps & DisplayProps & DetailsFormFieldProps) => {
  return (
    <DetailsFormBaseField<NumberInputWithSuggestionsProps>
      Display={NumberDisplay}
      Input={NumberInputWithSuggestions}
      {...props}
    />
  );
};

export default NumberFieldWithSuggestions;
